"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const chip_1 = require("react-toolbox/lib/chip");
const link_1 = __importDefault(require("react-toolbox/lib/link"));
const state_1 = require("../state");
const SideBarItem = (spotProps) => {
    const { spot, panTo, filter } = spotProps;
    const { name, genres } = spot;
    return (React.createElement("div", null,
        React.createElement("a", { href: "#", onClick: () => panTo(spot) }, name),
        genres.map((genre) => {
            return (React.createElement(chip_1.Chip, null,
                React.createElement(link_1.default, { href: "#", onClick: () => filter(genre) }, genre)));
        })));
};
const mapDispatchProps = (dispatch) => {
    return {
        filter: (visibleGenre) => dispatch(state_1.actions.filter(visibleGenre)),
        panTo: (spot) => dispatch(state_1.actions.panTo(spot)),
    };
};
exports.default = react_redux_1.connect(null, mapDispatchProps, ({}, { panTo, filter }, ownProps) => ({ panTo, filter, spot: ownProps.spot }))(SideBarItem);
